import useValidation from "../../hooks/useValidation"
import { useEffect } from "react"
import { PartnerChangeType } from "../../static/types/commonTypes/partnerChangeType"
import partnerChangeValidationSchema from "../../utils/validation/partnerCHangeValidationSchema"

type LeaderChangePropType = {
    checked: boolean,
    partnerChange: PartnerChangeType,
    changes: string[],
    updatePartnerChange: ( partialPartnerChange: Partial<PartnerChangeType> ) => void,
    onValidationChange: ( isValid: boolean ) => void
}

export default function PartnerChange ({
    checked,
    partnerChange,
    changes,
    updatePartnerChange,
    onValidationChange
}: LeaderChangePropType ) {

    const { errors, isValid } = useValidation( partnerChange, partnerChangeValidationSchema )

    useEffect( () => {
        onValidationChange( isValid )
    }, [ isValid, onValidationChange ])

    useEffect(() => {
        if( !partnerChange.change ) updatePartnerChange({ change: changes[0] || '' })
    }, [])

    return(
        <div className = "mb-3 row">

            <div className = "mb-3 row">

                <label htmlFor = "change" className = "col-sm-2 col-form-label"> Modification <strong className="text-danger">*</strong>  </label>

                <div className = "col-sm-10">

                    <select
                        className = { `form-select ${ ( checked && errors.change ) ? 'is-invalid' : ''}` }
                        name = "change"
                        id = "change"
                        value = { partnerChange.change }
                        onChange = { event => updatePartnerChange({ change: event.target.value } )}
                    >
                        {
                            changes.map( option => 
                                <option key = { option } value = {option}>
                                    {option}
                                </option>
                            )
                        }

                    </select>
                    {( checked && errors.change ) && <div className="invalid-feedback"> { errors.change } </div> }

                </div>

            </div>

        </div>
    )
}